import { FC, PropsWithChildren } from 'react';

import { SubmitButton } from '../Button/SubmitButton';

export const SubscribeFormSubmitButton: FC<PropsWithChildren> = ({ children }) => {
  return (
    <footer className="mt-6 mb-10 grid grid-cols-1 gap-4 md:grid-cols-2">
      <SubmitButton fullWidth>{children}</SubmitButton>
    </footer>
  );
};
